import axios from "axios";
import {BASE_URL} from "../../constants/API";

export async function getBlogHeader() {
    return await axios.get(BASE_URL + '/blog-headers?populate=image');
}

export async function getBlogDataContent() {
    return await axios.get(BASE_URL + '/blog-data-contents');
}